export default __webpack_public_path__ + "media/images/tick-white-daa6754f69911da1b5e67d83ec41b816.svg";